import { render, staticRenderFns } from "./AdmModeradoresView.vue?vue&type=template&id=c2efe6b0&scoped=true"
import script from "./AdmModeradoresView.vue?vue&type=script&lang=js"
export * from "./AdmModeradoresView.vue?vue&type=script&lang=js"
import style0 from "./AdmModeradoresView.vue?vue&type=style&index=0&id=c2efe6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2efe6b0",
  null
  
)

export default component.exports